import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  imports: [CommonModule, RouterOutlet],
  templateUrl: './app.html',
  styleUrls: ['./app.css']
})
export class App {
  title = 'Catena-X';

  constructor(private titleService: Title) { }

  ngOnInit(): void {
    // Set dynamic title based on environment
    const envSuffix = environment.stage && environment.stage != 'prod' ? ` (${environment.stage.toUpperCase()})` : '';
    this.titleService.setTitle(`${this.title}${envSuffix}`);
  }
}
